import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import { actions } from "app/redux/slice";
import { BoardType, IBoard } from "app/types";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getBoardIconIcon } from "../../containers/Home/containers/helpers";
import { actions as actionsBoard } from "../../redux/slice";
import { actions as actionsBoardSetting } from "../Settings/redux/slice";

interface LotOfBoardProps {
  readonly trigger?: React.ReactNode;
  readonly options: IBoard[];
}

const LotOfBoards: React.FC<LotOfBoardProps> = ({ trigger, options }) => {
  const params = useParams();
  const { id } = params;

  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleNav = (data: IBoard) => {
    dispatch(actionsBoardSetting.getBoard({ id: data._id }));
    dispatch(
      actionsBoard.doGetSelectedBoardData({
        id: data?._id,
        callback: () => {
          dispatch(
            actions.updateBoardOrderState({
              selectedId: id as string,
              clickedId: data._id,
            })
          );
          dispatch(actions.doUpdateBoardOrder());
          let newPath = "";
          if (data?.settings.Type === BoardType.Backlog) {
            newPath = `/app/${params.project}/${params.team}/boards/${data._id}/backlog`;
          } else {
            newPath = `/app/${params.project}/${params.team}/boards/${data._id}/${data?.settings?.viewType}/board`;
          }
          navigate(newPath);
        },
      })
    );
  };
  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align="start"
          className={`!px-0 !py-0 pb-2 bg-white border border-[#E9ECF2] cursor-pointer max-h-[380px] overflow-scroll max-w-[250px]`}
        >
          <div className="flex items-center gap-2 p-4 text-[#253858] text-base font-semibold border-b border-[#E9ECF2] sticky top-0 bg-white">
            Boards
          </div>
          {options?.map((option) => {
            return (
              <div
                key={option?._id}
                className="flex w-full items-center gap-3 text-sm font-normal text-black text-[#79808A] cursor-pointer hover:bg-[#F4F5F7] p-4 "
                onClick={() => {
                  handleNav(option);
                }}
              >
                {getBoardIconIcon(option)}
                <span className="truncate">{option?.name}</span>
              </div>
            );
          })}
        </PopoverContent>
      </Popover>
    </>
  );
};

export default LotOfBoards;
